function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19944",
    transform: "translate(-487 -177)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 625",
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    transform: "translate(487 177)",
    style: {
      fill: "#e0e0df",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19944",
    transform: "translate(-706.421 -155.838)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 609",
    cx: 3.338,
    cy: 3.338,
    r: 3.338,
    transform: "translate(1205 353)",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 610",
    cx: 3.338,
    cy: 3.338,
    r: 3.338,
    transform: "translate(1213.583 353)",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 611",
    cx: 3.338,
    cy: 3.338,
    r: 3.338,
    transform: "translate(1222.166 353)",
    style: {
      fill: "#7c7c7c"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotRound);
export default __webpack_public_path__ + "static/media/three-dot-round.9ea3d5abee26f32664685e3e4f16bfd8.svg";
export { ForwardRef as ReactComponent };